import React, { } from 'react'
import style from './Index.module.less'
import bgImg from '@imgs/logoBg.png'
import logoImg from '@imgs/logo.png'
// import { reducer, initialState } from './reducer'
import { RouteComponentProps } from 'react-router-dom'
import { companyName, appName, companyUrl } from '@js/config'
import Form from './components/Form'

function Main ({ history }: RouteComponentProps): React.ReactElement {
  return (
    <div className={style.container}>
      <div className={style['body-right']}>
        <img src={bgImg} />
      </div>
      <div className={style.content}>
        <div className={style['logo-line']}>
          <a href='http://service.xmac.org.cn/' className={style['logo-line-inner']}>
            <img className={style['logo-img']} src={logoImg} />
            <span>{companyName}</span>
            <span className={style['logo-point']} />
            <span>{appName}</span>
          </a>
        </div>
        <div className={style['form-container']}>
          <Form history={history} />
        </div>
      </div>
      <div className={style.foot}>
        <span>{companyName}  {companyUrl}</span>
        <a href="https://xyt.xcc.cn/getpcInfo?sn=1636659736130494464&language=CN&certType=8&url=*.xmac.org.cn" className={style['other-power']} target="_blank">
          <embed src="https://program.xinchacha.com/web/1636659736130494464=*.xmac.org.cn.svg"width="103" height="38" type="image/svg+xml"/>
        </a>
      </div>
    </div>
  )
}

export default Main
